import React from "react";
import "./FundersStrip.css";

const funders = [
  { name: "AIC STPINEXT Initiatives" },
  { name: "Indian Statistical Institute, Kolkata" },
  { name: "Government of Karnataka" },
  { name: "STPI Octane Program" },
  { name: "U2CA Consultancy." },
  { name: "Apiary, Govt. of Haryana" },
  { name: "BUZZARIA INDIA PRIVATE LIMITED" },
];

const FundersStrip = () => {
  return (
    <section className="funders-section" aria-labelledby="funders-heading">
      <header className="funders-header">
        <h2 id="funders-heading">Trusted By</h2>
        <p>
          We are proud to be supported by leading institutions & government
          initiatives.
        </p>
      </header>

      <div className="funders-list">
        {funders.map((funder, index) => (
          <span key={index} className="funder-pill">
            {funder.name}
          </span>
        ))}
      </div>

      <div className="funders-viewall">
        <a href="/investors">View All Funders →</a>
      </div>
    </section>
  );
};

export default FundersStrip;
